import { render, staticRenderFns } from "./tableProductsApproved.vue?vue&type=template&id=33a82116&scoped=true"
import script from "./tableProductsApproved.vue?vue&type=script&lang=js"
export * from "./tableProductsApproved.vue?vue&type=script&lang=js"
import style0 from "./tableProductsApproved.vue?vue&type=style&index=0&id=33a82116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a82116",
  null
  
)

export default component.exports